import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberNewThreadPage from "@/pages/member/MemberNewThreadPage";

export const Route = createFileRoute("/member/forums/new")({
  head: () => pageHead("Member · Forums · New", "AKIVA member · forums · new portal.", "/member/forums/new", true),
  component: MemberNewThreadPage,
});
